// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uf-menu-option-dropdown {
    /* background: red; */
    color: white;
    width: 40px;
    height: 40px;
    margin-left: 0px;
    justify-items: center;
    background: gray;
  }

  /* FriendMenuDropdown.css */
.frn-menu-dropdown {
  background: rgba(20, 20, 30, 0.95);
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
  overflow: hidden;
  animation: slideDown 0.2s ease-out;
}

.frn-menu-dropdown-item {
  padding: 14px 18px;
  cursor: pointer;
  transition: all 0.2s ease;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  color: white;
  font-size: 14px;
}

.frn-menu-dropdown-item:last-child {
  border-bottom: none;
}

.frn-menu-dropdown-item:hover {
  background: rgba(255, 255, 255, 0.1);
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Pages/AccountPage/Components/Friends/Styles/common-style.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,qBAAqB;IACrB,gBAAgB;EAClB;;EAEA,2BAA2B;AAC7B;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,0CAA0C;EAC1C,mBAAmB;EACnB,yCAAyC;EACzC,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,iDAAiD;EACjD,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF","sourcesContent":[".uf-menu-option-dropdown {\n    /* background: red; */\n    color: white;\n    width: 40px;\n    height: 40px;\n    margin-left: 0px;\n    justify-items: center;\n    background: gray;\n  }\n\n  /* FriendMenuDropdown.css */\n.frn-menu-dropdown {\n  background: rgba(20, 20, 30, 0.95);\n  backdrop-filter: blur(12px);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 12px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);\n  overflow: hidden;\n  animation: slideDown 0.2s ease-out;\n}\n\n.frn-menu-dropdown-item {\n  padding: 14px 18px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  color: white;\n  font-size: 14px;\n}\n\n.frn-menu-dropdown-item:last-child {\n  border-bottom: none;\n}\n\n.frn-menu-dropdown-item:hover {\n  background: rgba(255, 255, 255, 0.1);\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
